export default (palette, typography) => ({
  background: palette.background,
  border: palette.accent,
  borderRadius: 4,
  cancelButtonColor: palette.primary.normal,
  cancelButtonColorDisabled: palette.grey.G300,

  cancelButtonColorHover: palette.primary.light,

  cellButtonSpan: {
    borderRadius: 4,
    bottom: 0,
    fontSize: 12,
    height: 40,
    lineHeight: '36px',
    margin: '0 auto',
    position: 'absolute',
    width: 40,
  },

  // Cells Wrap
  cellsWrap: {
    '& thead tr:first-child td': {
      paddingBottom: 15,
    },
  },

  // Calendar wrapper chevron
  chevron: {
    '&::before': {
      background: palette.background,
      border: `solid ${palette.accent}`,
      borderWidth: '1px 0 0 1px',
      bottom: 'auto',
      content: '""',
      display: 'block',
      height: 8,
      left: 12,
      position: 'absolute',
      top: -5,
      transform: 'rotate(45deg)',
      width: 8,
      zIndex: 1,
    },
    marginTop: 8,
  },

  chevronAlignsRight: {
    '&::before': {
      left: 'auto',
      right: 12,
    },
  },

  chevronPointsDown: {
    '&::before': {
      borderWidth: '0 1px 1px 0',
      bottom: -5,
      top: 'auto',
    },
    marginBottom: 8,
  },

  dark: {
    inputIconButtonColor: palette.text.light,
  },

  darkFocusColor: palette.focus.dark,

  dateSelect: {
    background: palette.background,
    border: `1px solid ${palette.accent}`,
    borderRadius: 4,
    padding: 10,
  },

  dayBorderRadius: 4,

  // Calendar Days
  dayHoverBackground: palette.grey.G100,

  dayNames: {
    fontSize: 12,
  },

  disabledDate: 'rgba(0,0,0,0.1)',

  focusColor: palette.focus.normal,

  fontFamily: typography.fontFamily,

  iconFill: palette.text.dark,

  iconFillHover: palette.text.midGray,

  inRange: palette.text.dark,

  inRangeBackground: '#cbe4ff',

  input: {
    backgroundColor: 'inherit',
    color: palette.text.dark,
    dark: {
      backgroundColor: 'inherit',
      color: palette.text.light,
    },
  },

  inputBorderRadius: 4,

  inputHeight: 35,

  inputIconButtonColor: palette.text.dark,

  inputWrapper: {
    paddingRight: 34,
  },

  // Select day/period
  isToday: {
    '&::before': {
      borderRadius: 4,
      boxShadow: `0 0 0 1px ${palette.primary.normal}`,
      content: '""',
      height: 40,
      left: '50%',
      position: 'absolute',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      width: 40,
    },
  },

  labelHeight: 30,

  mobileBreakpoint: 800,

  monthSelectButton: {
    '&:hover': {
      backgroundColor: palette.grey.G200,
      borderRadius: 4,
    },
  },

  monthSelectIcon: {
    height: 12,
    marginTop: -6,
    width: 12,
  },

  // Select month
  monthSelectTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    lineHeight: '28px',
    textAlign: 'center',
    textTransform: 'initial',
  },

  // Month and Year dropdown
  monthYearDropdown: {
    border: `1px solid ${palette.accent}`,
    borderRadius: 4,
  },

  monthYearDropdownCaret: {
    height: 13,
    left: 19,
    top: 19,
    width: 13,
  },

  period: {
    margin: 0,
  },

  // Range Panel
  rangePanelBackground: palette.background,

  rangePanelBorder: palette.form.border,

  rangePanelHover: palette.highlightBackground,

  // Calendar wrapper
  rangeSelect: {
    background: palette.background,
    border: `1px solid ${palette.accent}`,
    borderRadius: 4,
  },

  // Select time
  selectBorder: 'none',

  selected: palette.primary.normal,

  selectedText: palette.text.light,
  text: palette.text.dark,

  textInput: {},

  textInputToggle: {
    right: 0,
    top: 27,
  },

  timepickerLabel: {},

  timepickerWrapper: {
    '& select option': {
      backgroundColor: palette.grey.G200,
    },
    backgroundColor: palette.grey.G200,
    border: 'none',
  },

  todayBorder: palette.primary.normal,

  weekHeader: palette.grey.G300,
  // Week numbers
  weekNumber: {
    color: palette.grey.G300,
    fontSize: 12,
    lineHeight: '19px',
  },
});
